import React, { useState } from "react";
import { Plus, Trash2, Users } from "lucide-react";

export function ListsSidebar(props) {
  const { lists, selectedListId, onSelectList, onCreateList, onDeleteList, loadingLists, saving } = props;

  const [newListName, setNewListName] = useState("");

  const handleCreate = () => {
    if (!newListName.trim()) return;
    onCreateList(newListName.trim());
    setNewListName("");
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 sticky top-8">
      <div className="px-5 pt-5 pb-4 border-b border-gray-200">
        <h2 className="text-base font-semibold text-gray-900 mb-3">Your Lists</h2>
        <div className="flex items-center gap-2.5">
          <input
            type="text"
            value={newListName}
            onChange={(e) => setNewListName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleCreate()}
            placeholder="New list..."
            className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-gray-400 bg-white transition-all"
          />
          <button
            onClick={handleCreate}
            disabled={!newListName.trim() || saving}
            className="px-3 py-2 bg-gray-900 hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed text-white rounded-lg text-sm font-medium transition-colors flex items-center justify-center flex-shrink-0"
            aria-label="Create list"
          >
            <Plus size={16} strokeWidth={2.25} />
          </button>
        </div>
      </div>

      <div className="max-h-[calc(100vh-240px)] overflow-y-auto">
        {loadingLists ? (
          <div className="py-12 text-center text-gray-500">
            <div className="inline-block animate-spin rounded-full h-5 w-5 border-b-2 border-gray-400" />
            <p className="mt-2 text-xs">Loading...</p>
          </div>
        ) : lists.length === 0 ? (
          <div className="py-12 text-center">
            <Users className="mx-auto text-gray-300 mb-3" size={24} />
            <p className="text-xs text-gray-500">No lists yet</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-100">
            {lists.map((list) => (
              <div
                key={list.id}
                onClick={() => onSelectList(list.id)}
                className={`px-4 py-3 flex justify-between items-center cursor-pointer transition-colors ${
                  selectedListId === list.id
                    ? "bg-gray-50 border-l-4 border-l-gray-900"
                    : "hover:bg-gray-50"
                }`}
              >
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-gray-900 truncate mb-1">{list.name}</div>
                  <div className="text-xs text-gray-500">
                    {list.playerIds.length} {list.playerIds.length === 1 ? "player" : "players"}
                  </div>
                </div>
                <button
                  onClick={(e) => { e.stopPropagation(); onDeleteList(list); }}
                  className="ml-3 text-gray-400 hover:text-red-600 p-1.5 rounded transition-colors flex-shrink-0"
                  aria-label={`Delete ${list.name}`}
                >
                  <Trash2 size={14} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
